/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9593f15f2c7938c3713cad864f1e0db7f071e314";
